import Block2Image from 'app/shared/images/listingLandingPageV2/post-listing-block-2-image.jpg';
import Block2Image2x from 'app/shared/images/listingLandingPageV2/post-listing-block-2-image@2x.jpg';
import Block2Overlay from 'app/shared/images/listingLandingPageV2/post-listing-block-2-overlay.png';
import Block2Overlay2x from 'app/shared/images/listingLandingPageV2/post-listing-block-2-overlay@2x.png';
import Block2OverlayWide from 'app/shared/images/listingLandingPageV2/post-listing-block-2-overlay-wide.png';
import Block2OverlayWide2x from 'app/shared/images/listingLandingPageV2/post-listing-block-2-overlay-wide@2x.png';
import Block3Image from 'app/shared/images/listingLandingPageV2/post-listing-block-3-image.jpg';
import Block3Image2x from 'app/shared/images/listingLandingPageV2/post-listing-block-3-image@2x.jpg';
import Block3Overlay from 'app/shared/images/listingLandingPageV2/post-listing-block-3-overlay.png';
import Block3Overlay2x from 'app/shared/images/listingLandingPageV2/post-listing-block-3-overlay@2x.png';
import Block3OverlayWide from 'app/shared/images/listingLandingPageV2/post-listing-block-3-overlay-wide.png';
import Block3OverlayWide2x from 'app/shared/images/listingLandingPageV2/post-listing-block-3-overlay-wide@2x.png';
import Block4Image from 'app/shared/images/listingLandingPageV2/post-listing-block-4-image.jpg';
import Block4Image2x from 'app/shared/images/listingLandingPageV2/post-listing-block-4-image@2x.jpg';
import Block4Overlay from 'app/shared/images/listingLandingPageV2/post-listing-block-4-overlay.png';
import Block4Overlay2x from 'app/shared/images/listingLandingPageV2/post-listing-block-4-overlay@2x.png';
import Block4OverlayWide from 'app/shared/images/listingLandingPageV2/post-listing-block-4-overlay-wide.png';
import Block4OverlayWide2x from 'app/shared/images/listingLandingPageV2/post-listing-block-4-overlay-wide@2x.png';
import Block5Image from 'app/shared/images/listingLandingPageV2/post-listing-block-5-image.jpg';
import Block5Image2x from 'app/shared/images/listingLandingPageV2/post-listing-block-5-image@2x.jpg';
import Block5Overlay from 'app/shared/images/listingLandingPageV2/post-listing-block-5-overlay.png';
import Block5Overlay2x from 'app/shared/images/listingLandingPageV2/post-listing-block-5-overlay@2x.png';
import Block5OverlayWide from 'app/shared/images/listingLandingPageV2/post-listing-block-5-overlay-wide.png';
import Block5OverlayWide2x from 'app/shared/images/listingLandingPageV2/post-listing-block-5-overlay-wide@2x.png';
import Block6StepOne from 'app/shared/images/listingLandingPageV2/post-listing-block-6-image-step1.png';
import Block6StepOne2x from 'app/shared/images/listingLandingPageV2/post-listing-block-6-image-step1@2x.png';
import Block6StepTwo from 'app/shared/images/listingLandingPageV2/post-listing-block-6-image-step2.png';
import Block6StepTwo2x from 'app/shared/images/listingLandingPageV2/post-listing-block-6-image-step2@2x.png';
import Block6StepThree from 'app/shared/images/listingLandingPageV2/post-listing-block-6-image-step3.png';
import Block6StepThree2x from 'app/shared/images/listingLandingPageV2/post-listing-block-6-image-step3@2x.png';

import Block7Image from 'app/shared/images/listingLandingPageV2/post-listing-block-7-image.jpg';
import Block7Image2x from 'app/shared/images/listingLandingPageV2/post-listing-block-7-image@2x.jpg';

import CrossPromoteOne from 'app/shared/images/listingLandingPageV2/post-listing-cross-promotoe-ico-1.png';
import CrossPromoteOne2x from 'app/shared/images/listingLandingPageV2/post-listing-cross-promotoe-ico-1@2x.png';
import CrossPromoteTwo from 'app/shared/images/listingLandingPageV2/post-listing-cross-promotoe-ico-2.png';
import CrossPromoteTwo2x from 'app/shared/images/listingLandingPageV2/post-listing-cross-promotoe-ico-2@2x.png';
import CrossPromoteThree from 'app/shared/images/listingLandingPageV2/post-listing-cross-promotoe-ico-3.png';
import CrossPromoteThree2x from 'app/shared/images/listingLandingPageV2/post-listing-cross-promotoe-ico-3@2x.png';
import CtaBackground from 'app/shared/images/listingLandingPageV2/post-listing-cta-background.jpg';
import CtaBackground2x from 'app/shared/images/listingLandingPageV2/post-listing-cta-background@2x.jpg';

import HeroImage from 'app/shared/images/listingLandingPageV2/post-listing-hero.jpg';
import HeroImage2x from 'app/shared/images/listingLandingPageV2/post-listing-hero@2x.jpg';

import ZillowLogo from 'app/shared/images/listingLandingPageV2/post-listing-block-2-zillow.png';
import ZillowLogo2x from 'app/shared/images/listingLandingPageV2/post-listing-block-2-zillow@2x.png';
import TruliaLogo from 'app/shared/images/listingLandingPageV2/post-listing-block-2-trulia.png';
import TruliaLogo2x from 'app/shared/images/listingLandingPageV2/post-listing-block-2-trulia@2x.png';
import HotPadsLogo from 'app/shared/images/listingLandingPageV2/post-listing-block-2-hotpads.png';
import HotPadsLogo2x from 'app/shared/images/listingLandingPageV2/post-listing-block-2-hotpads@2x.png';

export default {
    HeroImage,
    HeroImage2x,

    ZillowLogo,
    ZillowLogo2x,
    TruliaLogo,
    TruliaLogo2x,
    HotPadsLogo,
    HotPadsLogo2x,

    Block2Image,
    Block2Image2x,
    Block2Overlay,
    Block2Overlay2x,
    Block2OverlayWide,
    Block2OverlayWide2x,

    Block3Image,
    Block3Image2x,
    Block3Overlay,
    Block3Overlay2x,
    Block3OverlayWide,
    Block3OverlayWide2x,

    Block4Image,
    Block4Image2x,
    Block4Overlay,
    Block4Overlay2x,
    Block4OverlayWide,
    Block4OverlayWide2x,

    Block5Image,
    Block5Image2x,
    Block5Overlay,
    Block5Overlay2x,
    Block5OverlayWide,
    Block5OverlayWide2x,

    Block6StepOne,
    Block6StepOne2x,
    Block6StepTwo,
    Block6StepTwo2x,
    Block6StepThree,
    Block6StepThree2x,

    Block7Image,
    Block7Image2x,

    CrossPromoteOne,
    CrossPromoteOne2x,
    CrossPromoteTwo,
    CrossPromoteTwo2x,
    CrossPromoteThree,
    CrossPromoteThree2x,

    CtaBackground,
    CtaBackground2x,
};
